import GATSBY_COMPILED_MDX from "/home/pio/Projects/repo/projects/gawsoftcom/gawsoft/frontend/src/content/blog/headscale-litefs-consul.mdx";
import * as React from 'react';
import Seo from '../../components/Seo';
import {Page} from "../../components/Page";
const query = "3783743729";
const BlogPage = _ref => {
  let {data, children} = _ref;
  return React.createElement(Page, {
    post: data.mdx,
    pageText: children,
    otherPosts: data.allMdx.nodes,
    backTo: {
      name: "Back to blog list",
      url: "/blog"
    }
  });
};
export const Head = _ref2 => {
  var _data$mdx$frontmatter, _data$mdx$frontmatter2, _data$mdx$frontmatter3;
  let {data} = _ref2;
  return React.createElement(Seo, {
    title: (_data$mdx$frontmatter = (_data$mdx$frontmatter2 = data.mdx.frontmatter) === null || _data$mdx$frontmatter2 === void 0 ? void 0 : _data$mdx$frontmatter2.meta_title) !== null && _data$mdx$frontmatter !== void 0 ? _data$mdx$frontmatter : (_data$mdx$frontmatter3 = data.mdx.frontmatter) === null || _data$mdx$frontmatter3 === void 0 ? void 0 : _data$mdx$frontmatter3.title,
    post: data.mdx,
    url: "/blog/" + data.mdx.frontmatter.slug + "/"
  });
};
BlogPage
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPage, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
